/**
 * @generated SignedSource<<361ae493c953fbbcf1c8625fb9c8933f>>
 * @relayHash 045591dd5eb5241471ce7cad546365df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 085ade576cc8c394af1f6412716aed021f10a53b41203ee89390b210a13e11da

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareSummaryAppQuery } from './JiraSoftwareSummaryAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareSummaryAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "085ade576cc8c394af1f6412716aed021f10a53b41203ee89390b210a13e11da",
    "metadata": {},
    "name": "JiraSoftwareSummaryAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
